// extracted by mini-css-extract-plugin
export default {"headerWrapper":"header_headerWrapper__G8rko","header":"header_header__UKyNZ","fade-in":"header_fade-in__K40W9"};